import { ButtonBase, Typography, useTheme } from "@mui/material"
import { deepmerge } from "@mui/utils"
import { SearchIcon } from "../../icons"

export const SearchToggleButton = ({
  placeholder = "Search",
  onClick = () => {},
  icon: Icon = SearchIcon,
  sx = {},
  ...props
}) => {
  const theme = useTheme()
  const styleOverrides =
    theme.components[`VuiSearchToggleButton`]?.styleOverrides || {}
  const { root, searchIcon, label } = styleOverrides
  return (
    <ButtonBase
      variant="outlined"
      className="VuiSearchToggleButton-root"
      sx={deepmerge(root, sx)}
      onClick={onClick}
      {...props}
    >
      <Icon sx={searchIcon} />
      <Typography sx={label}>{placeholder}</Typography>
    </ButtonBase>
  )
}
